<template>
  <div v-if="loadOrganisation">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6" >
        <card class="bg-transparent" >
          <template slot="header">
            <div>
              <div>
                <h3 class="mb-0">{{ organisation.name }}</h3>
                <p class="text-sm mb-0">
                  Fleet driving style
                </p>
              </div>
            </div>
          </template>
          <div>
            <period-filter />
            <div>
              <driving-style-stats type="ORGANISATION"></driving-style-stats>
            </div>
          </div>
        </card>
    </b-container>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import StatsCard from '@/components/Cards/StatsCard';
import crudApi from "../../crud/crud-api";
import DrivingStyleStats from "../DrivingStyle/DrivingStyleStats";
import PeriodFilter from "../DrivingStyle/PeriodFilter";

export default {
  name: "organisation-overview",
  components: {
    StatsCard,
    RouteBreadCrumb,
    DrivingStyleStats,
    PeriodFilter
  },
  data: _ => ({
    organisation: {},
    drivers: [],
    assets: [],
    devices: [],
  }),
  computed: {
    loadOrganisation() {
      crudApi.getOrganisation(this.$store.state.auth.user.organisation_id).then(json => this.organisation = json.data ? json.data : json)
      return true
    },
    loadAssets() {
      crudApi.getAll('assets', this.$store.state.auth.user.organisation_id).then(json => this.assets = json.data ? json.data : json);
      return true
    },
    loadDrivers() {
      crudApi.getAll('drivers', this.$store.state.auth.user.organisation_id).then(json => this.drivers = json.data ? json.data : json);
      return true
    },
    loadDevices() {
      crudApi.getAll('devices', this.$store.state.auth.user.organisation_id).then(json => this.devices = json.data ? json.data : json);
      return true
    },
  }
}
</script>

<style scoped>

</style>
